import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import RequireAuth from "./components/RequireAuth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => (prev === "light" ? "dark" : "light"));

  return (
    <AuthProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin/*"
              element={
                <RequireAuth>
                  <AdminPage />
                </RequireAuth>
              }
            />
          </Routes>
        </main>
        <Footer />
        <Toaster theme={theme === "light" ? "light" : "dark"} position="bottom-right" toastOptions={{
          style: theme === "light" 
            ? { background: "#ffffff", border: "1px solid rgba(0,0,0,0.1)", color: "#1a1a1a", borderRadius: 2, fontFamily: "IBM Plex Mono" }
            : { background: "#0c0c0c", border: "1px solid rgba(255,255,255,0.1)", color: "#ededed", borderRadius: 2, fontFamily: "IBM Plex Mono" }
        }} />
      </div>
    </AuthProvider>
  );
}
